/**
 * The handshake between `instrumentation-client.ts` (which initialises Datadog RUM) and
 * `DatadogRumRouter` (which waits for it). Deliberately its own module, holding **only** a constant
 * and a global type — no imports, no side effects.
 *
 * It used to live in `instrumentation-client.ts`, and `DatadogRumRouter` imported it from there.
 * That import is a *value* import from a client component, so Next.js pulled the whole of
 * `instrumentation-client.ts` into the **server** bundle of every page — `DatadogRumRouter` is
 * mounted in the root layout. Its module-scope `initDatadogClient()` then ran during SSR and threw
 * `ReferenceError: window is not defined`, surfacing as an unhandled rejection on every render.
 *
 * `instrumentation-client.ts` is a Next.js client-only entrypoint: the framework loads it in the
 * browser, and nothing about it is meant to execute on the server. Keeping shared constants out of
 * it is what stops an innocent-looking import from dragging it across that boundary.
 */

export const DATADOG_RUM_READY_EVENT = "datadog-rum-ready";

declare global {
  interface Window {
    __datadogRumReady?: boolean;
  }
}
